import { AuthGuard } from '@/modules/auth/router/auth.guard';

export default [
    {
        name: 'organization:edit',
        path: '/organisation',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/EditOrganization.vue'),
        meta: { title: 'Organisation' },
        beforeEnter: AuthGuard,
    },
    {
        name: 'organization-registration',
        path: '/organisation-registration',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/OrganizationRegistration.vue'),
        meta: { title: 'Organisation Registration' },
    },
    {
        name: 'unverified-organization',
        path: '/unverified-organisation',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/UnverifiedOrganization.vue'),
        meta: { title: 'Unverified Organisation' },
    },
];
